export default "__VITE_ASSET__Nz_vkPlO__"